import { render, staticRenderFns } from "./SetPwdStep2.vue?vue&type=template&id=a1042fbc"
import script from "./SetPwdStep2.vue?vue&type=script&lang=js"
export * from "./SetPwdStep2.vue?vue&type=script&lang=js"
import style0 from "./SetPwdStep2.vue?vue&type=style&index=0&id=a1042fbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports